import React,{ Component, Fragment } from "react";
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import { getArrays } from 'lib';
import PropTypes from 'prop-types';
import moment from 'moment';
import { setCheckoutPlanParams,clearCheckoutPlanParams, updateCheckoutPlanParams } from '../../store/checkoutPlanParams';
import { setCheckoutMealPlan,updateCheckoutMealPlan,clearCheckoutMealPlan } from '../../store/checkoutMealPlan';
import { spin, stop } from '../../store/spinner'; 
import { setModal, clearModal } from '../../store/modal';
import Tabs from '../../components/Checkout/Tabs';
import BottomNav from '../../components/Checkout/BottomNav';
import Days from '../../components/Checkout/Days';
import Notpaidnotification from '../../components/Checkout/Notpaidnotification';
import { browserHistory } from "react-router";
import PaperButton from 'react-paper-button';

class CheckoutStep4 extends Component{

    constructor(props) {
        super(props);
        const { checkoutMealPlan, checkoutPlanParams } =this.props;
        const { id:checkoutId } = checkoutPlanParams;
        console.debug('checkoutPlanParams');
        console.debug(checkoutPlanParams);
        if(checkoutPlanParams==undefined) browserHistory.push('/meal-plans');
        const today = moment().startOf('day');
        const startDate = (checkoutMealPlan)?Object.keys(checkoutMealPlan)[0]:'';
        const date = moment.unix(startDate); 
        const buffered = today.unix()> startDate || date.isBetween(today, today.clone().add(3, 'day'), '[)');
        if(buffered) browserHistory.push('/checkout/delivery-dates');
        this.state={
            activeStamp:(checkoutMealPlan)?Object.keys(checkoutMealPlan)[0]:'',
            testing:'main'
        }
       
    }
    validateMealPlan = () =>{
      const { checkoutMealPlan,checkoutPlanParams } = this.props;
      if(Object.keys(checkoutMealPlan).length<=0 || checkoutPlanParams==undefined) {browserHistory.push('/meal-plans'); return false;};
      return true;
    }
    componentDidMount(){
      const { socket } = this.props;
      if(socket.connected){
          this.initializeData();
      }else{
          socket.on('connect', (data) => {
              this.initializeData();
          });
      } 
    }
    initializeData =() =>{
        const { socket, dataArray, user } = this.props;
        const types = ['productsList','dietList','typeList','ingredientList','emirate','emirateSlots'].filter(el => !(el in dataArray));    
        types.length && getArrays(socket, types);
        this.getPending(user.user_id);
    }

    componentWillMount() {
        this.props.socket.on('mobile_checkout', this.listener);
    }
    componentWillUnmount() {
      this.props.socket.removeListener('mobile_checkout', this.listener);
    }
    setPlan = () =>{
      const { checkoutPlanParams,user,checkoutMealPlan } =this.props;
      const { priceDatas } = checkoutPlanParams;
      // console.log('checkoutPlanParams');
      // console.log(checkoutPlanParams);
      // console.log(checkoutMealPlan);
      let checkDates = Object.keys(checkoutMealPlan);
      let checkOutdata ={...checkoutPlanParams,user_id:user.user_id,full_price:priceDatas.price,discount_price:priceDatas.savedAmount,start_date:checkDates[0],end_date:checkDates[(checkDates.length)-1]};
      // console.log(checkOutdata); 
      // console.log(checkoutMealPlan);
      this.props.socket.emit('mobile_checkout', { type: 'set',   data: {
        checkoutPlanParams:checkOutdata,
        detailsData: checkoutMealPlan
      }});
      // props.stop();
   }
    listener = ({ type, data, message }) => {
        this.props.stop();
        
        const { checkoutMealPlan, setCheckoutPlanParams, setCheckoutMealPlan, updateCheckoutMealPlan, updateCheckoutPlanParams,user } = this.props;
        switch (type) {
          case 'setOk':
          if(data.planParams!=undefined){
            setCheckoutPlanParams(data.planParams);
            setCheckoutMealPlan(data.mealPlan);
          }
        break;
          case 'getPendingOk':
            // setIsSkip(true);
            // this.setState({planParams:data.planParams,mealPlan:data.mealPlan});
            if( data && data.mealPlan !=undefined ){
             
              setCheckoutPlanParams(data.planParams);
              setCheckoutMealPlan(data.mealPlan);
              const { diet_id,mealTypes } = data.planParams;
              this.getDefaultDishes(diet_id,mealTypes);
              if(Object.keys(data.mealPlan).length>0){
                this.setState({activeStamp:Object.keys(data.mealPlan)[0]});
              }
          }else if(user.token){
           console.info('clearData');
           console.info(user.token);
           if(Object.keys(checkoutMealPlan).length>0){
              this.setPlan();
           }else{
            this.props.clearCheckoutMealPlan();
            this.props.clearCheckoutPlanParams();
            browserHistory.push('/meal-plans');
           }
          }
          break;
          case 'setMealPlanOk':
            //console.log(data);
            const {  checkoutMealPlanUpdate } = data;
            if(checkoutMealPlanUpdate){
                Object.keys(checkoutMealPlanUpdate).map((currentDate) => {
                  Object.keys(checkoutMealPlanUpdate[currentDate]).map((currentType) => {
                    setCheckoutMealPlan({ ...checkoutMealPlan, [currentDate]: { ...checkoutMealPlan[currentDate], [currentType]: checkoutMealPlanUpdate[currentDate][currentType]} });                    
                  });
                });
            }
            updateCheckoutPlanParams({priceDatas:priceDatas});
            //setIsMenuUpdated(false);
            // Alert.alert(
            //   'Your menu is updated.',
            // )
            // if(isSave){
              // navigation.navigate('BuildMenuSummary');
            // }
          break;
          case 'skipTheDayOk':
            delete checkoutMealPlan[data.skipDate];
            setCheckoutMealPlan(checkoutMealPlan);
            updateCheckoutMealPlan(data.newDate,data.newMealplan);
            this.setState({activeStamp:data.newDate});
            break;
            case 'removeOk':
              setCheckoutPlanParams({});
              setCheckoutMealPlan({});
             browserHistory.push('/meal-plans');
            break;
          case 'setMealPlanErr':
            console.log(data);
            console.log(message);
          break;
          case 'viewmenupdfOk':
          this.props.stop();
          window.open(data.url, '_blank');
          // this.props.setModal({ headLine: '  ', message: (
          //   <div className='viewmenupdf'>
          //     <p align="center">
          //         <PaperButton className='button-regular next transition'
          //           onClick={ (e) => {
                      
          //           }}
          //         >
          //         <span className="">View my menu in PDF</span>
          //         </PaperButton>
          //     </p>
          //   </div>)}); 
        break;
        }
      }
    getPending = user_id => this.props.socket.emit('mobile_checkout', { type: 'getPending', data: { user_id } });
    
   
    skipTheDay = (date, new_date) => {
        const { checkoutPlanParams } = this.props;
        var planId =  checkoutPlanParams.id; 
        if(planId){
          this.props.spin();
          this.props.socket.emit('mobile_checkout', { type: 'skipTheDay', data: { skip_date: date, new_date: new_date, planId: planId }});
        }
      }
       removeCheckout = () => {
        const { checkoutPlanParams,user } = this.props;
        var planId =  checkoutPlanParams.id; 
        if(planId && user.token){
          this.props.spin();
          this.props.socket.emit('mobile_checkout', { type: 'remove', data: {checkoutId: planId }});
        }else{
            this.props.clearCheckoutMealPlan();
            this.props.clearCheckoutPlanParams();
            browserHistory.push('/meal-plans');
        }
      }
      viewMenuPDF = () =>{
        const { checkoutPlanParams } = this.props;
        var planId =  checkoutPlanParams.id; 
        if(planId){
          this.props.spin();
          this.props.socket.emit('mobile_checkout', { type: 'viewmenupdf', data: {checkoutId: planId }});
        }
      }
      getDefaultDishes = (dietId, types) => { 
        // this.props.spin();
        this.props.socket.emit('default_dishes', { type: 'get', data: { dietId, types } });
        this.props.socket.emit('custom_plan', { type: 'get', data: { diet_id:dietId, mealTypes:types } });
      };
      validate =()=>{
        const { checkoutMealPlan,checkoutPlanParams } = this.props;
        const { days_count } = checkoutPlanParams;
        // const today = moment().startOf('day');
        // const startDate = (checkoutMealPlan)?Object.keys(checkoutMealPlan)[0]:'';
        // const date = moment.unix(startDate); 
        // const buffered = date.isBetween(today, today.clone().add(3, 'day'), '[)');
        // if(buffered){
        //   browserHistory.push('/checkout/delivery-dates');
        //   return false;
        // }
        // console.log('days_count');
        // console.log(days_count);
        // console.log(Object.keys(checkoutMealPlan).length);
        if(days_count!=Object.keys(checkoutMealPlan).length){
          alert(
            'Meal plan days and generate meals count are mismatched. Please check days count or Delete and Start Over meal plan.'
          )
          return false;
        }
        return true;
    }
    updateDayMeals =(checkoutId,detailsData,deliveryName=null)=>{
     
        if(checkoutId && detailsData){
          this.props.spin();
          // detailsData
          this.props.socket.emit('mobile_checkout', { type: 'setMealPlan',   data: {
            checkoutId:checkoutId,
            checkoutMealPlan: detailsData,
            deliveryName:deliveryName
          }});
        }else{
          if(detailsData){
            const { checkoutMealPlan, setCheckoutMealPlan } = this.props;
            Object.keys(detailsData).map((currentDate) => {
              // console.debug('currentDate');
              // console.debug(currentDate);
              Object.keys(detailsData[currentDate]).map((currentType) => {
              //   console.debug('currentType');
              // console.debug(currentType);
              // console.debug(detailsData[currentDate][currentType]);
                setCheckoutMealPlan({ ...checkoutMealPlan, [currentDate]: { ...checkoutMealPlan[currentDate], [currentType]: detailsData[currentDate][currentType]} });                    
              });
            });
        }
        }
    }
    render() {
        const { checkoutPlanParams } = this.props;
        const { priceDatas,diet_id,id:checkoutId } = checkoutPlanParams;const { dishList } = this.state; 

        if(!this.validateMealPlan()){
          return false;
        }
        return <Fragment>
            <div className="main-holder checkout-process-con wrap-progress-page" >
            <Notpaidnotification />
            <div className="container checkout-process menus">
                        <div className="row">
                        <div className='col-12'>
                           <div className="inner-content">
                            <h2 className="mobile-header">Menu</h2>
                           <Days {...this.props} skipTheDay={this.skipTheDay} updateDayMeals={this.updateDayMeals}  />
                           </div>
                           <BottomNav isLogin={this.props.user.token} priceDatas={priceDatas} continueValid={this.validate} viewMenuPDF={this.viewMenuPDF} removeCheckout={this.removeCheckout} isShowBag={true} />
                        </div>
                    </div>
                    </div>
              </div>
        </Fragment>
    }
}
CheckoutStep4.propTypes = {
    checkoutPlanParams: PropTypes.object.isRequired,
    checkoutMealPlan: PropTypes.object.isRequired,
    setCheckoutMealPlan: PropTypes.func.isRequired,
    setCheckoutPlanParams: PropTypes.func.isRequired,
    dataArray: PropTypes.object.isRequired
};
  
const mapStateToProps = state => ({
    checkoutPlanParams: state.checkoutPlanParams,
    dataArray: state.dataArray,
    user:state.user,
    checkoutMealPlan: state.checkoutMealPlan,
    customPlanSides:state.customPlanSides,
    customPlans: state.customPlans
});

const bindAction = dispatch => ({
    setModal: obj => dispatch(setModal(obj)),
    setCheckoutMealPlan: plan => dispatch(setCheckoutMealPlan(plan)),
    setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
    updateCheckoutPlanParams: obj => dispatch(updateCheckoutPlanParams(obj)),
    spin: () => dispatch(spin()),
    stop: () => dispatch(stop()),
    updateCheckoutMealPlan: (date,obj) => dispatch(updateCheckoutMealPlan(date,obj)),
    clearCheckoutMealPlan: () => dispatch(clearCheckoutMealPlan()),
    clearCheckoutPlanParams: () => dispatch(clearCheckoutPlanParams()),
    clearModal: obj => dispatch(clearModal(obj))
});
  
export default socketConnect(connect(mapStateToProps, bindAction)(CheckoutStep4));